module.exports = __webpack_public_path__ + "img/5.b7c2d449.png";